import ky from 'ky';
import { ENV } from 'src/utils/env';

export const editRecentlyViewedDevices = async (devices: Array<string>) => {
  try {
    await ky.post(`${ENV.FRONTEND_API_URL}/edit-recently-viewed-devices`, {
      body: JSON.stringify(devices),
    });
  } catch (error) {
    console.error(error);
  }

  return true;
};

export const editRecentlyViewedOrgs = async (devices: Array<string>) => {
  try {
    await ky.post(`${ENV.FRONTEND_API_URL}/edit-recently-viewed-orgs`, {
      body: JSON.stringify(devices),
    });
  } catch (error) {
    console.error(error);
  }

  return true;
};
